import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';
import { CommonService } from "../common.service";
var AppAiCoachComponent = (function () {
    function AppAiCoachComponent(route, router, commonService, platformLocation) {
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.assetsRoute = "../../assets";
    }
    AppAiCoachComponent.prototype.ngOnInit = function () {
    };
    AppAiCoachComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({ 'backgroundColor': 'rgba(255,255,255,1)' });
    };
    AppAiCoachComponent.prototype.goLearningMap = function () {
        if (localStorage.getItem('onlyCamp')) {
            this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId'), -1]);
        }
        else {
            this.router.navigate(['learning-map']);
        }
    };
    return AppAiCoachComponent;
}());
export { AppAiCoachComponent };



// WEBPACK FOOTER //
// ./src/app/app-ai-coach/app-ai-coach.component.ts.pre-build-optimizer.js